import React from 'react';
import { Link } from 'react-router-dom';

import { PageHeader } from '../ui/PageHeader';
import { Card } from '../ui/Card';

export default function PartnerPage() {
  return (
    <div className="page heroPage">
      <div className="container">
        <PageHeader
          kicker="Partner With Us"
          title="Join a Network Built on Trust"
          subtitle="SafariCo Hub is a member association, not a marketplace — every guide, operator, and agency we vet becomes part of how our charitable work reaches the ground."
        />

        <div style={{ marginTop: 32, display: 'grid', gap: 18, gridTemplateColumns: 'repeat(3, 1fr)' }}>
          <Card title="Partner Login">
            <div className="kicker">For verified operators & guides.</div>
            <p className="muted" style={{ marginTop: 12 }}>
              Access your dashboard to manage your profile, documents, and availability as a
              vetted SafariCo Hub partner.
            </p>

            <div style={{ marginTop: 16 }}>
              <Link className="btn btnPrimary" to="/partner/login">
                Login
              </Link>
            </div>
          </Card>

          <Card title="Get Verified">
            <div className="kicker">Apply to join SafariCo Hub as a trusted partner.</div>
            <p className="muted" style={{ marginTop: 12 }}>
              Operators and guides can apply for verification to join our vetted, community‑driven
              network — the same network our donors and travelers rely on.
            </p>

            <div style={{ marginTop: 16 }}>
              <Link className="btn btnWarn" to="/partner/apply">
                Start Verification
              </Link>
            </div>
          </Card>

          <Card title="Support the Network">
            <div className="kicker">Fund the communities behind every safari.</div>
            <p className="muted" style={{ marginTop: 12 }}>
              Every donation funds conservation, education, and community-led development across
              East Africa.
            </p>

            <div style={{ marginTop: 16 }}>
              <Link className="btn btnPrimary" to="/donations">
                Donation
              </Link>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
}
